import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Text, Tooltip, Wrapper } from 'components';
import { selectSite } from 'store/Site';
import { IDaySegment, IEmployerSite, PermissionType } from 'types';
import { hasSitePermission } from 'utils/employers';
import { SettingCardContainer, StyledIconButton } from '../../../styles';
import { TipCalculationsDescription } from '../../../TipCalculator/shared/styles';
import { GracePeriodForm } from './GracePeriodForm';
import { GracePeriodItem } from './GracePeriodItem';

interface IGracePeriodProps {
  currentSite: IEmployerSite;
  daySegments?: IDaySegment[];
}

export const GracePeriod: React.FC<IGracePeriodProps> = ({ currentSite, daySegments }) => {
  const siteWithSettings = useSelector(selectSite());
  const [isEditing, setIsEditing] = useState(false);
  const onClose = () => setIsEditing(false);
  const editPermission = hasSitePermission(currentSite?.permissions, PermissionType.SITE_DAYSEGMENT_UPDATE);
  const { gracePeriodPolicy } = siteWithSettings?.settings || {};

  return (
    <SettingCardContainer data-cy="grace-period-settings" disabled={!isEditing}>
      <Wrapper direction="row" justifyContent="space-between" gap={0} noWrap>
        <Wrapper direction="column" gap={4}>
          <Text size="small" fontWeight="semibold">
            Grace Period
          </Text>
          <TipCalculationsDescription size="xsmall">
            Specify a Grace Period to smooth shift transitions. Employees clocking out slightly late stay in the earlier segment. Employees clocking in slightly early count toward the next segment. Set to 0 to disable this behavior.
          </TipCalculationsDescription>
        </Wrapper>
        {!isEditing && (
          <>
            <StyledIconButton label="Edit" appearance="white" icon="Edit" data-cy="edit-button" onClick={() => setIsEditing(true)} disabled={!editPermission} tooltipId="no-grace-period-permission" />
            {!editPermission && (
              <Tooltip id="no-grace-period-permission">
                You do not have permission to edit grace period.
                <br />
                Contact your supervisor for more information.
              </Tooltip>
            )}
          </>
        )}
      </Wrapper>

      {!isEditing ? <GracePeriodItem gracePeriodPolicy={gracePeriodPolicy} /> : <GracePeriodForm site={siteWithSettings} daySegments={daySegments} onClose={onClose} />}
    </SettingCardContainer>
  );
};
